/**
 * React Query mutation hook for microservice generation (form submission).
 * Replaces manual isGenerating/jobURL/generationError state.
 */
import { useMutation } from '@tanstack/react-query';
import { useAccessToken } from '@app/auth';
import { fetchApi } from '@app/hooks/api';

export function useGenerateMicroservice() {
    const getToken = useAccessToken();

    return useMutation<string, Error, any>({
        mutationFn: async (formData: any) => {
            const response = await fetchApi<{ jobUrl: string }>(
                '/api/microservicegenerator/submit',
                getToken,
                {
                    method: 'POST',
                    body: JSON.stringify(formData),
                }
            );
            return response.jobUrl;
        },
    });
}
